export default "/assets/photos.svg";